<template>
  <modal
    name="editAdquirente"
    height="auto"
    width="900"
    :scrollable="true"
    :clickToClose="false"
    @before-close="resetEdit"
  >
    <CloseModal :close="close" />
    <div class="modalbox">
      <div class="modalbox-content">
        <div class="form-body">
          <div v-if="message" class="bdti-alert bdti-alert-success">
            {{ message }}
          </div>
          <div v-if="error" class="bdti-alert bdti-alert-danger">
            {{ error }}
          </div>

          <div class="section-label section-label--primeira">
            <fa-icon icon="credit-card" class="section-label__icone" />
            Dados da Adquirente
          </div>
          <div v-show="secoes.dados">
            <div class="xrow">
              <div class="col-2-3">
                <div class="form-group">
                  <label>Nome <span class="text-danger">*</span></label>
                  <input
                    class="form-control"
                    autocomplete="chrome-off"
                    placeholder="Nome que identifica esta adquirente na listagem"
                    v-model="adquirente.nome"
                  />
                  <div class="message">
                    {{ validation.firstError("adquirente.nome") }}
                  </div>
                </div>
              </div>
              <div class="col-1-3">
                <div class="form-group">
                  <label>Ambiente <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="adquirente.ambiente">
                    <option value="HOMOLOGACAO">Homologação</option>
                    <option value="PRODUCAO">Produção</option>
                  </select>
                  <div class="message">
                    {{ validation.firstError("adquirente.ambiente") }}
                  </div>
                </div>
              </div>
            </div>

            <div class="xrow">
              <div class="col-1-3">
                <div class="form-group">
                  <label>Gateway <span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model="adquirente.gateway"
                    v-on:change="cleanUnusedFields"
                  >
                    <option
                      v-for="(gateway, key) in gatewaysDisponiveis"
                      v-bind:key="key"
                      :value="key"
                    >
                      {{ gateway }}
                    </option>
                  </select>
                  <div class="message">
                    {{ validation.firstError("adquirente.gateway") }}
                  </div>
                </div>
              </div>
              <div class="col-1-3">
                <div class="form-group">
                  <label
                    >Forma de pagamento
                    <span class="text-danger">*</span></label
                  >
                  <select class="form-control" v-model="adquirente.cobranca_id">
                    <option
                      v-for="cobranca in cobrancasDisponiveis"
                      v-bind:key="cobranca.id"
                      :value="cobranca.id"
                    >
                      {{ cobranca.desc }}
                    </option>
                  </select>
                  <div class="message">
                    {{ validation.firstError("adquirente.cobranca_id") }}
                  </div>
                </div>
              </div>
              <div class="col-1-3">
                <div class="form-group">
                  <label
                    >Ordem de tentativa
                    <span class="text-danger">*</span></label
                  >
                  <select class="form-control" v-model="adquirente.ordem">
                    <option
                      v-for="(ordem, index) in ordensDisponiveis"
                      v-bind:key="index"
                      :value="ordem"
                    >
                      {{ ordem }}
                    </option>
                  </select>
                  <div class="message">
                    {{ validation.firstError("adquirente.ordem") }}
                  </div>
                </div>
              </div>
            </div>

            <div class="xrow" v-if="exibe('processa_pgto')">
              <div class="col-1-2">
                <div class="form-group">
                  <label>Processar pagamento em</label>
                  <select
                    class="form-control"
                    v-model="adquirente.processa_pgto"
                  >
                    <option :value="1">
                      1 etapa (autoriza e captura junto)
                    </option>
                    <option :value="2">
                      2 etapas (autoriza agora, captura depois)
                    </option>
                  </select>
                  <div class="message">
                    {{ validation.firstError("adquirente.processa_pgto") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="section-label" v-on:click="alternarSecao('credenciais')">
            <fa-icon icon="key" class="section-label__icone" />
            Credenciais
            <fa-icon
              :icon="secoes.credenciais ? 'chevron-up' : 'chevron-down'"
              class="section-label__seta"
            />
          </div>
          <div v-show="secoes.credenciais">
            <div class="xrow">
              <div class="col-1-2" v-if="exibe('merchant_id')">
                <div class="form-group">
                  <label
                    >{{ rotulo("merchant_id") }}
                    <span class="text-danger">*</span></label
                  >
                  <input
                    class="form-control"
                    autocomplete="chrome-off"
                    :placeholder="dica('merchant_id')"
                    v-model="adquirente.merchant_id"
                  />
                  <div class="message">
                    {{ validation.firstError("adquirente.merchant_id") }}
                  </div>
                </div>
              </div>
              <div class="col-1-2" v-if="exibe('merchant_key')">
                <div class="form-group">
                  <label>{{ rotulo("merchant_key") }}</label>
                  <input
                    class="form-control"
                    autocomplete="chrome-off"
                    :placeholder="dica('merchant_key')"
                    v-model="adquirente.merchant_key"
                  />
                  <div class="message">
                    {{ validation.firstError("adquirente.merchant_key") }}
                  </div>
                </div>
              </div>
            </div>

            <div class="xrow" v-if="exibeAlgum(['seller_id', 'chave_pix'])">
              <div class="col-1-2" v-if="exibe('seller_id')">
                <div class="form-group">
                  <label>Seller Id</label>
                  <input
                    class="form-control"
                    autocomplete="chrome-off"
                    placeholder="Identificador do vendedor na adquirente"
                    v-model="adquirente.seller_id"
                  />
                  <div class="message">
                    {{ validation.firstError("adquirente.seller_id") }}
                  </div>
                </div>
              </div>
              <div class="col-1-2" v-if="exibe('chave_pix')">
                <div class="form-group">
                  <label>Chave Pix</label>
                  <input
                    class="form-control"
                    autocomplete="chrome-off"
                    :placeholder="
                      dica('chave_pix') ||
                      'CNPJ, e-mail, telefone ou chave aleatória'
                    "
                    v-model="adquirente.chave_pix"
                  />
                  <div class="message"></div>
                </div>
              </div>
            </div>

            <template v-if="exibe('certificados')">
              <div class="xrow">
                <div class="col-1-2">
                  <div class="form-group">
                    <label>Certificado PSP</label>
                    <div
                      class="upload-arquivo"
                      :class="{
                        'upload-arquivo--preenchido': !!nomeCertificado('psp'),
                      }"
                    >
                      <input
                        type="file"
                        accept=".pem,.cer"
                        class="upload-arquivo__input"
                        v-on:change="setPsp"
                      />
                      <div class="upload-arquivo__icone">
                        <fa-icon
                          :icon="
                            nomeCertificado('psp') ? 'check-circle' : 'upload'
                          "
                        />
                      </div>
                      <div class="upload-arquivo__nome">
                        {{ nomeCertificado("psp") || "Selecionar certificado" }}
                      </div>
                      <div class="upload-arquivo__dica">
                        {{
                          nomeCertificado("psp")
                            ? "Clique para substituir"
                            : "Arquivo .pem ou .cer"
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-1-2">
                  <div class="form-group">
                    <label>Certificado APP</label>
                    <div
                      class="upload-arquivo"
                      :class="{
                        'upload-arquivo--preenchido': !!nomeCertificado('app'),
                      }"
                    >
                      <input
                        type="file"
                        accept=".key"
                        class="upload-arquivo__input"
                        v-on:change="setApp"
                      />
                      <div class="upload-arquivo__icone">
                        <fa-icon
                          :icon="
                            nomeCertificado('app') ? 'check-circle' : 'upload'
                          "
                        />
                      </div>
                      <div class="upload-arquivo__nome">
                        {{ nomeCertificado("app") || "Selecionar certificado" }}
                      </div>
                      <div class="upload-arquivo__dica">
                        {{
                          nomeCertificado("app")
                            ? "Clique para substituir"
                            : "Arquivo .key"
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="xrow">
                <div class="col-1-2">
                  <div class="form-group">
                    <label>Senha do certificado APP</label>
                    <input
                      type="password"
                      class="form-control"
                      autocomplete="new-password"
                      placeholder="Senha do arquivo do certificado"
                      v-model="adquirente.senha_certificado_app"
                    />
                    <div class="message"></div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <template v-if="exibe('autenticacao_3ds')">
            <div
              class="section-label"
              v-on:click="alternarSecao('autenticacao')"
            >
              <fa-icon icon="lock" class="section-label__icone" />
              Autenticação 3DS
              <fa-icon
                :icon="secoes.autenticacao ? 'chevron-up' : 'chevron-down'"
                class="section-label__seta"
              />
            </div>
            <div v-show="secoes.autenticacao">
              <div class="xrow">
                <div class="col-1-1">
                  <div class="toggle-row">
                    <span class="toggle-row__label">
                      Exigir autenticação do portador no banco emissor
                      <small class="toggle-row__hint">
                        Reduz fraude e transfere ao banco a responsabilidade por
                        contestação
                      </small>
                    </span>
                    <label class="toggle-switch">
                      <input
                        type="checkbox"
                        v-model="adquirente.autenticacao_ativa"
                      />
                      <span class="toggle-slider"></span>
                      <span class="toggle-text">
                        {{
                          adquirente.autenticacao_ativa ? "Ativo" : "Inativo"
                        }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <template v-if="adquirente.autenticacao_ativa">
                <div class="autenticacao-detalhes">
                  <div class="subsecao-label">
                    <fa-icon icon="sliders-h" class="subsecao-label__icone" />
                    Configuração da autenticação
                  </div>

                  <div class="xrow">
                    <div class="col-1-1">
                      <div class="form-group">
                        <label class="label-com-ajuda">
                          Opções de autenticação 3DS
                          <button
                            type="button"
                            class="botao-ajuda"
                            :class="{
                              'botao-ajuda--ativo': mostrarAjudaPolitica,
                            }"
                            :aria-expanded="
                              mostrarAjudaPolitica ? 'true' : 'false'
                            "
                            v-on:click="
                              mostrarAjudaPolitica = !mostrarAjudaPolitica
                            "
                          >
                            <fa-icon icon="info-circle" />
                          </button>
                        </label>
                        <select
                          class="form-control"
                          v-model="politicaEscolhida"
                        >
                          <!-- Sem valor e desabilitada: serve de rótulo quando nada foi escolhido
                               e impede salvar sem decidir, agora que o campo é obrigatório. -->
                          <option value="" disabled>
                            Selecione o que fazer quando a autenticação falhar
                          </option>
                          <option value="ACEITA_NAO_AUTENTICADA">
                            Aceitar pagamento mesmo se a autenticação falhar.
                          </option>
                          <option value="EXIGE_AUTENTICACAO">
                            Recusar pagamento em caso de falha na autenticação
                            do banco ou da bandeira.
                          </option>
                          <option value="EXIGE_EMISSOR">
                            Recusar pagamento em caso de falha na autenticação
                            do banco emissor.
                          </option>
                        </select>
                        <div class="message">
                          {{
                            validation.firstError(
                              "adquirente.autenticacao_politica"
                            )
                          }}
                        </div>

                        <div
                          class="politica-ajuda"
                          v-if="mostrarAjudaPolitica && explicacaoPolitica"
                        >
                          {{ explicacaoPolitica }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="xrow">
                    <div class="col-1-2">
                      <div class="form-group">
                        <label
                          >Client ID <span class="text-danger">*</span></label
                        >
                        <input
                          class="form-control"
                          autocomplete="chrome-off"
                          placeholder="00000000-0000-0000-0000-000000000000"
                          v-model="adquirente.autenticacao_client_id"
                        />
                        <div class="message">
                          {{
                            validation.firstError(
                              "adquirente.autenticacao_client_id"
                            )
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="col-1-2">
                      <div class="form-group">
                        <label
                          >Client Secret
                          <span class="text-danger">*</span></label
                        >
                        <input
                          type="password"
                          class="form-control"
                          autocomplete="new-password"
                          :placeholder="
                            adquirente.autenticacao_client_secret_cadastrado
                              ? 'Já cadastrado — preencha para substituir'
                              : 'Chave secreta gerada com o Client ID'
                          "
                          v-model="adquirente.autenticacao_client_secret"
                        />
                        <div class="message">
                          {{
                            validation.firstError(
                              "adquirente.autenticacao_client_secret"
                            )
                          }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="xrow">
                    <div class="col-1-3">
                      <div class="form-group">
                        <label
                          >Estabelecimento
                          <span class="text-danger">*</span></label
                        >
                        <input
                          class="form-control"
                          maxlength="10"
                          autocomplete="chrome-off"
                          placeholder="10 dígitos, sem pontuação"
                          v-model="adquirente.autenticacao_estabelecimento"
                        />
                        <div class="message">
                          {{
                            validation.firstError(
                              "adquirente.autenticacao_estabelecimento"
                            )
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="col-1-3">
                      <div class="form-group">
                        <label>MCC <span class="text-danger">*</span></label>
                        <input
                          class="form-control"
                          maxlength="4"
                          autocomplete="chrome-off"
                          placeholder="4 dígitos (ex.: 5399)"
                          v-model="adquirente.autenticacao_mcc"
                        />
                        <div class="message">
                          {{
                            validation.firstError("adquirente.autenticacao_mcc")
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="col-1-3">
                      <div class="form-group">
                        <label
                          >Razão social
                          <span class="text-danger">*</span></label
                        >
                        <input
                          class="form-control"
                          maxlength="25"
                          autocomplete="chrome-off"
                          placeholder="Como aparece na fatura do portador"
                          v-model="adquirente.autenticacao_razao_social"
                        />
                        <div class="message">
                          {{
                            validation.firstError(
                              "adquirente.autenticacao_razao_social"
                            )
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>

          <div class="section-label" v-on:click="alternarSecao('exibicao')">
            <fa-icon icon="list" class="section-label__icone" />
            Filiais
            <fa-icon
              :icon="secoes.exibicao ? 'chevron-up' : 'chevron-down'"
              class="section-label__seta"
            />
          </div>
          <div v-show="secoes.exibicao">
            <div class="xrow">
              <div class="col-1-2">
                <div class="form-group">
                  <div class="lista-dupla">
                    <div class="lista-dupla__cabecalho">
                      <span>Filiais disponíveis</span>
                      <span class="lista-dupla__contador">
                        {{ filiaisDisponiveis.length }}
                      </span>
                    </div>
                    <ul class="lista-dupla__itens">
                      <li
                        v-for="filial in filiaisDisponiveis"
                        v-bind:key="filial.id"
                        class="lista-dupla__item"
                        v-on:click="vincularFilial(filial.id)"
                        :title="'Vincular ' + filial.razSoc"
                      >
                        <span class="lista-dupla__texto">
                          <strong>{{ filial.id }}</strong> {{ filial.razSoc }}
                        </span>
                        <fa-icon icon="plus" class="lista-dupla__acao" />
                      </li>
                      <li
                        v-if="!filiaisDisponiveis.length"
                        class="lista-dupla__vazio"
                      >
                        Todas as filiais já estão vinculadas
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-1-2">
                <div class="form-group">
                  <div class="lista-dupla lista-dupla--vinculadas">
                    <div class="lista-dupla__cabecalho">
                      <span>Filiais selecionadas</span>
                      <span
                        class="lista-dupla__limpar"
                        v-if="filiaisVinculadas.length"
                        v-on:click="limparFiliais()"
                      >
                        Limpar
                      </span>
                      <span v-else class="lista-dupla__contador">0</span>
                    </div>
                    <ul class="lista-dupla__itens">
                      <li
                        v-for="filial in filiaisVinculadas"
                        v-bind:key="filial.id"
                        class="lista-dupla__item"
                        v-on:click="desvincularFilial(filial.id)"
                        :title="'Remover ' + filial.razSoc"
                      >
                        <span class="lista-dupla__texto">
                          <strong>{{ filial.id }}</strong> {{ filial.razSoc }}
                        </span>
                        <fa-icon icon="times" class="lista-dupla__acao" />
                      </li>
                      <li
                        v-if="!filiaisVinculadas.length"
                        class="lista-dupla__vazio"
                      >
                        Clique nas filiais à esquerda para vincular
                      </li>
                    </ul>
                  </div>
                  <div class="message">
                    {{ validation.firstError("adquirente.filiais") }}
                  </div>
                </div>
              </div>
            </div>

            <div class="xrow">
              <div class="col-1-1">
                <div class="form-group">
                  <label>Instruções exibidas ao cliente (opcional)</label>
                  <EditorConteudo :item="this.adquirente"></EditorConteudo>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer-bar">
      <CButton variant="outline" color="secondary" @click="close"
        >Fechar</CButton
      >
      <CButton
        color="primary"
        :disabled="validation.hasError()"
        @click="handleSubmit"
      >
        {{ modoDeEdicao ? "Alterar" : "Cadastrar" }}
      </CButton>
    </div>
  </modal>
</template>

<script>
import SimpleVueValidation from "simple-vue-validator";
import CloseModal from "../../../../components/CloseModal";
import EditorConteudo from "../../../../components/EditorConteudo.vue";

const Validator = SimpleVueValidation.Validator.create({
  templates: {
    required: "Campo de preenchimento obrigatório.",
    greaterThan: "Valor deve ser maior que {0}",
  },
});

/**
 * O que cada adquirente exibe no formulário.
 *
 * Antes isso vivia em três listas invertidas (linkGateways, linkGatewaysPix,
 * linkGatewaysOff) consultadas por helpers de nome parecido e combinadas com condições
 * negativas no template. Descobrir se um campo aparecia para um gateway exigia cruzar as três
 * listas de cabeça, e cada campo novo somava mais uma negativa.
 *
 * Aqui cada adquirente declara o que usa, e os rótulos ficam ao lado do campo que nomeiam —
 * a mesma credencial se chama Merchant Key na Cielo e Client Secret na Getnet.
 *
 * `campos` aceita: merchant_id, merchant_key, seller_id, chave_pix, certificados,
 * processa_pgto e autenticacao_3ds.
 */
const CONFIGURACAO_GATEWAYS = {
  CIELO: {
    campos: [
      "merchant_id",
      "merchant_key",
      "processa_pgto",
      "autenticacao_3ds",
    ],
    rotulos: {
      merchant_id: "Public Key (PV)",
      merchant_key: "Merchant Key (Token)",
    },
    dicas: {
      merchant_id: "Public Key fornecida pela Cielo",
      merchant_key: "Token de acesso da loja",
    },
  },
  REDECARD: {
    campos: ["merchant_id", "merchant_key", "processa_pgto"],
    rotulos: {
      merchant_id: "Public Key (PV)",
      merchant_key: "Merchant Key (Token)",
    },
    dicas: {
      merchant_id: "PV da loja na Rede",
      merchant_key: "Token de integração",
    },
  },
  PAGBANK: {
    campos: ["merchant_id", "merchant_key", "processa_pgto"],
    rotulos: {
      merchant_id: "Public Key (PV)",
      merchant_key: "Merchant Key (Token)",
    },
    dicas: {
      merchant_id: "Public Key da conta PagBank",
      merchant_key: "Token de integração",
    },
  },
  GETNET: {
    campos: ["merchant_id", "merchant_key", "seller_id"],
    rotulos: {
      merchant_id: "Client Id",
      merchant_key: "Client Secret",
    },
    dicas: {
      merchant_id: "Client Id da aplicação",
      merchant_key: "Client Secret da aplicação",
    },
  },
  PICPAY: {
    campos: ["merchant_id", "processa_pgto"],
    rotulos: {
      merchant_id: "Seller ID",
    },
    dicas: {
      merchant_id: "Seller ID informado pelo PicPay",
    },
  },
  PIX: {
    campos: ["chave_pix", "processa_pgto"],
    rotulos: {},
  },
  PIX_SICREDI: {
    campos: ["merchant_id", "merchant_key", "chave_pix", "certificados"],
    rotulos: {
      merchant_id: "Client Id",
      merchant_key: "Client Secret",
    },
    dicas: {
      merchant_id: "Client Id do app no Sicredi",
      merchant_key: "Client Secret do app",
      chave_pix: "CNPJ, e-mail, telefone ou chave aleatória",
    },
    dicas: {
      chave_pix: "CNPJ, e-mail, telefone ou chave aleatória",
    },
  },
  PIX_ITAU: {
    campos: ["merchant_id", "merchant_key", "chave_pix", "certificados"],
    rotulos: {
      merchant_id: "Client Id",
      merchant_key: "Client Secret",
    },
    dicas: {
      merchant_id: "Client Id do app no Itaú",
      merchant_key: "Client Secret do app",
      chave_pix: "CNPJ, e-mail, telefone ou chave aleatória",
    },
  },
  PIX_FAKE: {
    campos: ["merchant_id", "merchant_key", "chave_pix"],
    rotulos: {
      merchant_id: "Client Id",
      merchant_key: "Client Secret",
    },
    dicas: {
      merchant_id: "Qualquer valor (simulador)",
      merchant_key: "Qualquer valor (simulador)",
      chave_pix: "Qualquer valor (simulador)",
    },
  },
  FAKE_ADQUIRENTE: {
    campos: [
      "merchant_id",
      "merchant_key",
      "processa_pgto",
      "autenticacao_3ds",
    ],
    rotulos: {
      merchant_id: "Public Key (PV)",
      merchant_key: "Merchant Key (Token)",
    },
    dicas: {
      merchant_id: "Qualquer valor (simulador)",
      merchant_key: "Qualquer valor (simulador)",
    },
  },
};

// Gateway desconhecido cai aqui: mostra as credenciais genéricas em vez de sumir com o
// formulário inteiro.
const CONFIGURACAO_PADRAO = {
  campos: ["merchant_id", "merchant_key", "processa_pgto"],
  rotulos: {
    merchant_id: "Public Key (PV)",
    merchant_key: "Merchant Key (Token)",
  },
  dicas: {
    merchant_id: "Identificador da loja na adquirente",
    merchant_key: "Chave de integração da loja",
  },
};

/**
 * O que cada política faz com a venda quando o banco emissor não confirma o portador — situação
 * comum e não excepcional: cartão fora do 3DS, emissor indisponível, bandeira sem suporte.
 */
const EXPLICACAO_POLITICA = {
  ACEITA_NAO_AUTENTICADA:
    "Nenhum pagamento é recusado em razão do 3DS: os confirmados pelo banco passam a ter a responsabilidade por contestação de fraude transferida ao emissor, e os demais seguem conforme o fluxo anterior à adoção do protocolo. Recomendada para o início da operação, porque cartões corporativos e de benefício frequentemente não participam do programa.",
  EXIGE_AUTENTICACAO:
    "Somente pagamentos confirmados pelo banco emissor ou pela bandeira em nome dele são processados, e a responsabilidade por contestação de fraude é sempre do emissor. Os demais são recusados antes do envio à adquirente, sem qualquer cobrança, inclusive com cartão válido que não participe do 3DS.",
  EXIGE_EMISSOR:
    "Somente pagamentos confirmados pelo próprio banco emissor são processados. A confirmação realizada pela bandeira em substituição ao emissor não é aceita, o que torna esta a opção mais restritiva e recusa mais pagamentos que a anterior.",
};

/**
 * Credencial do 3DS só é obrigatória com a autenticação ligada — quem não usa 3DS não deve ser
 * impedido de salvar por campos que não lhe dizem nada (nem vê, no PIX e nos gateways sem 3DS).
 *
 * O `required()` do simple-vue-validator recebe a MENSAGEM de erro, não uma condição: passar o
 * booleano ali exigia o campo sempre e travava o botão Alterar de toda adquirente sem 3DS
 * (DEV-11014). A condição fica aqui, fora da regra.
 *
 * Desligado, devolve a regra sem nada exigido em vez de `undefined`: com `undefined` a
 * biblioteca não reavalia o campo e o erro de quando a autenticação estava ligada fica preso.
 * Por isso também cada chave observa `adquirente.autenticacao_ativa` — ligar ou desligar o
 * toggle reavalia as credenciais na hora.
 *
 * `undefined` vira `null` porque a biblioteca lança "Validator.value not set" com ele — e o
 * segredo nunca vem da API, então chega ausente em toda edição.
 */
function obrigatorioComAutenticacao(value, ativa) {
  const regra = Validator.value(value === undefined ? null : value);

  return ativa ? regra.required() : regra;
}

export default {
  name: "adquirente-edit",
  props: [
    "adquirente",
    "cobrancasDisponiveis",
    "gatewaysDisponiveis",
    "ordensDisponiveis",
    "modoDeEdicao",
    "salvar",
    "close",
    "message",
    "error",
    "resetEdit",
  ],
  components: {
    CloseModal,
    EditorConteudo,
  },
  data() {
    return {
      filiais: [],
      // Todas abertas por padrão: recolher é escolha de quem usa. Abrir o cadastro com seções
      // fechadas esconderia campo obrigatório de quem cadastra pela primeira vez.
      // A explicacao da politica fica atras do botao de informacao: quem ja conhece as opcoes nao
      // precisa dela ocupando espaco no formulario a cada abertura do cadastro.
      mostrarAjudaPolitica: false,
      secoes: {
        dados: true,
        credenciais: true,
        autenticacao: true,
        exibicao: true,
      },
    };
  },
  computed: {
    /**
     * Política escolhida, com o vazio normalizado para string.
     *
     * O select só marca a opção cujo `value` bate exatamente com o modelo, e o campo chega como
     * `null` (adquirente antiga) ou ausente (cadastro novo) — nenhum dos dois casa com `value=""`.
     * Sem esta normalização o campo abre sem nada selecionado, deixando a opção-rótulo invisível.
     */
    politicaEscolhida: {
      get() {
        return this.adquirente.autenticacao_politica || "";
      },
      set(valor) {
        this.adquirente.autenticacao_politica = valor;
      },
    },
    /**
     * Sem política escolhida devolve vazio, e o bloco nem aparece: mostrar o efeito de uma opção
     * que não está selecionada seria pior que não explicar nada.
     */
    explicacaoPolitica() {
      return EXPLICACAO_POLITICA[this.adquirente.autenticacao_politica] || "";
    },
    /**
     * Filiais ainda não vinculadas.
     */
    filiaisDisponiveis() {
      const vinculadas = this.adquirente.filiais || [];

      return this.filiais.filter((filial) => vinculadas.indexOf(filial.id) < 0);
    },
    /**
     * Vinculadas na ordem do cadastro de filiais, e não na ordem de clique.
     */
    filiaisVinculadas() {
      const vinculadas = this.adquirente.filiais || [];

      return this.filiais.filter(
        (filial) => vinculadas.indexOf(filial.id) >= 0
      );
    },
    configuracao() {
      return (
        CONFIGURACAO_GATEWAYS[this.adquirente.gateway] || CONFIGURACAO_PADRAO
      );
    },
  },
  watch: {
    "adquirente.instrucoes": {
      handler() {
        if (this.adquirente.instrucoes) {
          this.adquirente.conteudo = this.adquirente.instrucoes;
        }
      },
    },
  },
  methods: {
    handleSubmit(e) {
      if (e && e.preventDefault) {
        e.preventDefault();
      }

      this.salvar(this.modoDeEdicao, this.adquirente);
    },
    alternarSecao(secao) {
      this.secoes = { ...this.secoes, [secao]: !this.secoes[secao] };
    },
    vincularFilial(filialId) {
      const vinculadas = this.adquirente.filiais || [];

      if (vinculadas.indexOf(filialId) < 0) {
        this.adquirente.filiais = vinculadas.concat(filialId);
      }
    },
    desvincularFilial(filialId) {
      this.adquirente.filiais = (this.adquirente.filiais || []).filter(
        (id) => id !== filialId
      );
    },
    limparFiliais() {
      this.adquirente.filiais = [];
    },
    exibe(campo) {
      return this.configuracao.campos.indexOf(campo) >= 0;
    },
    exibeAlgum(campos) {
      return campos.some((campo) => this.exibe(campo));
    },
    rotulo(campo) {
      return this.configuracao.rotulos[campo] || campo;
    },
    /**
     * Texto de exemplo do campo. Vem do mapa do gateway porque a mesma credencial tem nome e
     * formato diferentes em cada adquirente — o que a Cielo chama de Public Key, a Getnet chama
     * de Client Id.
     */
    dica(campo) {
      return (this.configuracao.dicas || {})[campo] || "";
    },
    cleanUnusedFields() {
      this.adquirente.merchant_key = "";
      this.adquirente.processa_pgto = 1;
      this.adquirente.certificados = [];
    },
    /**
     * Nome do certificado a exibir: o recém-escolhido tem precedência sobre o já salvo, para
     * a área refletir o que será enviado ao salvar.
     */
    nomeCertificado(tipo) {
      const escolhido = (this.adquirente.certificados || []).find(
        (certificado) => certificado.name === tipo
      );

      if (escolhido && escolhido.file) {
        return escolhido.file.name;
      }

      const salvos = this.adquirente.certificados_link || {};
      const salvo =
        tipo === "psp"
          ? salvos.certificado_psp_name
          : salvos.certificado_app_name;

      const nome = this.getFileName(salvo);

      return nome === "Sem arquivo" ? null : nome;
    },
    getFileName(filePath) {
      if (filePath) {
        var splitedPath = filePath.split("/");
        return splitedPath[3];
      }
      return "Sem arquivo";
    },
    setApp(e) {
      if (e) {
        this.adquirente.certificados.forEach((certificado) => {
          if (certificado.name === "app") {
            this.adquirente.certificados.splice(certificado);
          }
        });
        this.adquirente.certificados.push({
          file: e.target.files[0],
          name: "app",
        });
      }
    },
    setPsp(e) {
      if (e) {
        this.adquirente.certificados.forEach((certificado) => {
          if (certificado.name === "psp") {
            this.adquirente.certificados.splice(certificado);
          }
        });
        this.adquirente.certificados.push({
          file: e.target.files[0],
          name: "psp",
        });
      }
    },
  },
  validators: {
    "adquirente.nome": (value) => Validator.value(value).required(),
    "adquirente.gateway": (value) => Validator.value(value).required(),
    "adquirente.cobranca_id": (value) => Validator.value(value).required(),
    "adquirente.ambiente": (value) => Validator.value(value).required(),
    "adquirente.ordem": (value) => Validator.value(value).required(),
    "adquirente.merchant_id": (value) => Validator.value(value).required(),

    /*
     * Credenciais do 3DS: exigidas só com a autenticação ligada, e todas juntas — credencial
     * incompleta não autentica nada, o token falha na adquirente e a venda segue sem proteção
     * (ou é recusada, se a política exigir). Deixar passar meio preenchido só transfere o erro
     * para a hora do pagamento, longe de quem cadastrou.
     */
    "adquirente.autenticacao_politica, adquirente.autenticacao_ativa":
      obrigatorioComAutenticacao,
    "adquirente.autenticacao_client_id, adquirente.autenticacao_ativa":
      obrigatorioComAutenticacao,
    "adquirente.autenticacao_estabelecimento, adquirente.autenticacao_ativa":
      obrigatorioComAutenticacao,
    "adquirente.autenticacao_mcc, adquirente.autenticacao_ativa":
      obrigatorioComAutenticacao,
    "adquirente.autenticacao_razao_social, adquirente.autenticacao_ativa":
      obrigatorioComAutenticacao,

    /*
     * O segredo é a exceção: nunca volta para a tela (fica criptografado) e o servidor preserva
     * o valor salvo quando o campo chega vazio. Exigir na edição obrigaria a colar a chave a
     * cada ajuste de ordem, filial ou política.
     */
    "adquirente.autenticacao_client_secret, adquirente.autenticacao_ativa":
      function (value, ativa) {
        return obrigatorioComAutenticacao(
          value,
          ativa && !this.adquirente.autenticacao_client_secret_cadastrado
        );
      },
  },
  beforeMount() {
    const { filiais } = JSON.parse(localStorage.getItem("app"));
    this.filiais = filiais;
  },
};
</script>

<style scoped>
/* ----- BARRA DE ROLAGEM DO MODAL -----

   Quem rola é o corpo (`.modalbox-content`, com max-height no CSS global), e a barra dele nasce
   na borda do proprio elemento — ou seja, a 32px da borda do modal, que e o padding do box. Isso
   a deixa desalinhada do X do topo, que fica a ~10px. Alem disso o overlay do vue-js-modal pode
   habilitar uma segunda barra, essa rente a borda.

   A correcao move o padding direito do box para dentro do conteudo: a soma continua 32px, o
   texto nao se desloca, e a barra sobe para a mesma coluna do botao de fechar. */
::v-deep .v--modal {
  overflow-y: hidden;
}

.modalbox {
  padding-right: 11px;
}

.modalbox-content {
  padding-right: 21px;
}

/* .section-label e .modal-footer-bar nao existem em CSS global: cada modal do projeto
   define as suas. Valores iguais aos de Perfis/PerfilFormModal.vue, para o cadastro de
   adquirente ficar visualmente no mesmo idioma das telas novas. */
/* A divisória acompanha o título em vez de ser uma régua solta acima dele: acento na cor
   primária, texto, e a linha esmaecendo para a direita — separa as seções sem cortar o
   formulário em faixas. */
/* Tarja de secao: faixa de ponta a ponta com acento na cor primaria a esquerda. O fundo e o
   acento sao o que dizem "isto e um bloco de configuracao" — antes o titulo flutuava sobre o
   formulario e se lia como mais um rotulo de campo. Continua sendo o alvo do clique do
   drill-down, agora com area bem maior que o texto. */
.section-label {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-left: 3px solid #3a3e81;
  border-radius: 3px;
  background-color: #f2f4f7;
  font-size: 13px;
  font-weight: 700;
  color: #475467;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin: 22px 0 16px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.15s ease;
}

.section-label:hover {
  background-color: #eaecf0;
}

.section-label:hover,
.section-label:hover .section-label__seta {
  color: #3a3e81;
}

/* ::after é sempre o último filho no fluxo; a ordem explícita mantém a linha entre o título
   e a seta. */
.section-label::after {
  order: 1;
}

.section-label__seta {
  order: 2;
  font-size: 11px;
  color: #98a2b3;
  flex-shrink: 0;
}

.section-label__icone {
  color: #3a3e81;
  font-size: 13px;
  flex-shrink: 0;
}

/* Dentro da tarja a regua nao tem o que separar: o proprio fundo faz esse trabalho. O ::after
   fica so como espacador, empurrando a seta para a direita. */
.section-label::after {
  content: "";
  flex: 1;
}

/* A primeira seção abre o formulário, sem afastamento extra do topo. */
.section-label--primeira {
  margin-top: 4px;
}

/* Seção sem seta é seção que não colapsa: sem cursor de clique nem realce no hover, para a
   tarja não prometer uma ação que não existe. */
.section-label:not(:has(.section-label__seta)) {
  cursor: default;
}

.section-label:not(:has(.section-label__seta)):hover {
  background-color: #f2f4f7;
  color: #475467;
}

.form-body .form-group {
  margin-bottom: 10px;
}

/* Mesmos valores do <style> nao-scoped de Colaboradores/Edit.vue. Lá eles valem para
   qualquer .modalbox da aplicacao, entao dependiam de a tela de colaborador ter sido
   aberta antes; aqui ficam fixos. */
.form-body .form-group > label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

.form-body .form-control {
  font-size: 13px;
}

.form-body .message {
  font-size: 11px;
  color: #d92d20;
  margin-top: 2px;
}

/* O rotulo do toggle e do upload nao seguem a caixa alta dos labels de campo: sao frases. */
.toggle-row__label,
.upload-arquivo__nome,
.upload-arquivo__dica {
  text-transform: none;
  letter-spacing: 0;
}

/* Toggle no padrão das telas novas (Cupons, Descontos): a classe não é global. */
/* Sem divisoria embaixo e sem margem: a linha separava o toggle dos campos que ele proprio
   abre, justamente o oposto do que a tela precisa dizer. O vinculo agora e feito pela barra
   do bloco filho, que sobe ate aqui. */
.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
}
.toggle-row__label {
  font-size: 13px;
  color: #333;
}
.toggle-switch input {
  display: none;
}
.toggle-slider {
  position: relative;
  width: 36px;
  height: 20px;
  background-color: #ccc;
  border-radius: 20px;
  transition: background-color 0.2s;
  flex-shrink: 0;
}
.toggle-slider::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}
.toggle-switch input:checked + .toggle-slider {
  background-color: #3a3e81;
}
.toggle-switch input:checked + .toggle-slider::after {
  transform: translateX(16px);
}
.toggle-text {
  font-size: 12px;
  color: #777;
  min-width: 28px;
}

.toggle-row__label {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.toggle-row__hint {
  font-size: 11px;
  color: #98a2b3;
  font-weight: 400;
}

.toggle-switch {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
}

/* Lista dupla de filiais, no mesmo idioma do restante do modal: caixa arredondada,
   cabeçalho discreto e item inteiro clicável — o botãozinho por linha do padrão antigo
   ficava desalinhado dentro do formulário. */
.lista-dupla {
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.lista-dupla__cabecalho {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  background: #f9fafb;
  border-bottom: 1px solid #e4e7ec;
  font-size: 11px;
  font-weight: 700;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.lista-dupla__contador {
  background: #eef0f5;
  color: #667085;
  border-radius: 10px;
  padding: 1px 8px;
  font-size: 11px;
}

.lista-dupla__limpar {
  color: #d92d20;
  cursor: pointer;
  font-size: 11px;
  text-transform: none;
  letter-spacing: 0;
}

.lista-dupla__limpar:hover {
  text-decoration: underline;
}

.lista-dupla__itens {
  list-style: none;
  margin: 0;
  padding: 0;
  height: 280px;
  overflow-y: auto;
}

.lista-dupla__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 7px 12px;
  font-size: 12px;
  color: #344054;
  border-bottom: 1px solid #f2f4f7;
  cursor: pointer;
  transition: background 0.12s ease;
}

.lista-dupla__item:last-child {
  border-bottom: none;
}

.lista-dupla__item:hover {
  background: #f7f7fc;
}

.lista-dupla--vinculadas .lista-dupla__item:hover {
  background: #fdf6f5;
}

.lista-dupla__texto strong {
  color: #667085;
  margin-right: 4px;
}

.lista-dupla__acao {
  color: #98a2b3;
  flex-shrink: 0;
}

.lista-dupla__item:hover .lista-dupla__acao {
  color: #3a3e81;
}

.lista-dupla--vinculadas .lista-dupla__item:hover .lista-dupla__acao {
  color: #d92d20;
}

.lista-dupla__vazio {
  padding: 16px 12px;
  font-size: 12px;
  color: #98a2b3;
  text-align: center;
}

/* Área de upload no mesmo idioma visual do imp-drop usado no modal de importação, em
   versão compacta: aqui são dois certificados lado a lado dentro do formulário. */
.upload-arquivo {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 14px 12px;
  border: 2px dashed #dddce9;
  border-radius: 10px;
  background: #fafbfc;
  cursor: pointer;
  text-align: center;
  transition: all 0.15s ease;
}

.upload-arquivo:hover {
  border-color: #3a3e81;
  background: #f7f7fc;
}

.upload-arquivo--preenchido {
  border-style: solid;
  border-color: #b9e7be;
  background: #f5fbf6;
}

.upload-arquivo__input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.upload-arquivo__icone {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f2f8;
  color: #3a3e81;
  margin-bottom: 2px;
}

.upload-arquivo--preenchido .upload-arquivo__icone {
  background: #e7f6e9;
  color: #2e7d32;
}

.upload-arquivo__nome {
  font-size: 12px;
  font-weight: 600;
  color: #344054;
  word-break: break-all;
}

.upload-arquivo__dica {
  font-size: 11px;
  color: #98a2b3;
}

/* Os campos abaixo só existem com o 3DS habilitado. A barra lateral e o rótulo os amarram ao
   toggle: sem eles pareciam campos independentes que apareceram do nada. */
/* Filho do toggle: recuado, ligado por uma barra que sobe ate a linha do parametro (o ::before
   fecha o trecho vertical que sobra acima do bloco) e com um degrade que apaga a barra no fim,
   para o vinculo morrer junto com os campos em vez de virar mais uma regua na tela.

   O tom e discreto de proposito: o acento na cor primaria pertence a tarja, que abre secao. */
.autenticacao-detalhes {
  position: relative;
  /* O respiro entre a barra e o texto e generoso de proposito: com pouco espaco a barra parece
     encostada no conteudo e vira ruido em vez de indentacao. */
  padding: 5px 0 2px 26px;
  margin: 16px 0 8px 10px;
}

/* Barra do vinculo pai-filho: comeca na altura da linha do toggle (o ::before cobre o trecho
   acima do bloco) e apaga no fim, para o vinculo morrer junto com os campos em vez de virar
   mais uma regua na tela. O tom e discreto de proposito — o acento na cor primaria pertence a
   tarja, que abre secao; aqui o assunto e outro: estes campos existem por causa do toggle. */
.autenticacao-detalhes::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(
    to bottom,
    #c9cee0 0%,
    #c9cee0 70%,
    rgba(201, 206, 224, 0) 100%
  );
}

/* Trecho que sobe do bloco ate a linha do parametro, fechando a ligacao. */
.autenticacao-detalhes::before {
  content: "";
  position: absolute;
  left: 0;
  /* Cobre o vao inteiro ate a linha do toggle — inclusive a margem do topo do bloco. Se ficar
     menor que ela, a barra descola do parametro e a ligacao pai-filho se perde. */
  top: -26px;
  width: 2px;
  height: 26px;
  background-color: #c9cee0;
}

.subsecao-label {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 11px;
  font-weight: 700;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin: 0 0 14px;
}

.subsecao-label::after {
  content: "";
  flex: 1;
  height: 1px;
  background: linear-gradient(to right, #dfe3e8, rgba(223, 227, 232, 0));
}

.subsecao-label__icone {
  color: #3a3e81;
  font-size: 11px;
  flex-shrink: 0;
}

.autenticacao-detalhes .label-com-ajuda {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* Botao discreto: e um atalho para a explicacao, nao uma acao do formulario. Ganha a cor
   primaria quando aberto, para ficar claro de onde o texto veio. */
.botao-ajuda {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #98a2b3;
  font-size: 13px;
  cursor: pointer;
  transition: color 0.15s ease, background-color 0.15s ease;
}

/* Hover apenas escurece o icone; o fundo e reservado ao estado aberto, senao passar o mouse
   parece abrir a explicacao. */
.botao-ajuda:hover {
  color: #667085;
}

.botao-ajuda--ativo,
.botao-ajuda--ativo:hover {
  color: #3a3e81;
  background-color: #eef0f8;
}

.politica-ajuda {
  background: #fff;
}

.politica-ajuda {
  /* A margem de baixo e maior que a de cima de proposito: o bloco explica o campo logo acima,
     e sem esse respiro ele encostava nos campos de credencial que vem em seguida, parecendo
     parte deles. */
  margin: 2px 0 20px;
  padding: 12px 14px;
  background: #f9fafb;
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  font-size: 12px;
  color: #344054;
}

.modal-footer-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #e9ecef;
  background: #fff;
}
</style>
